<template>
  <div class="player">
    <div class="playerCon">
        <div class="player-audio-list" id="js-playlist">
            <div class="playlist-top">
                <h4>播放列表</h4>
                <div id="js-playlist-close" class="close" @click="closePlayList">X</div>
            </div>
            <div class="playlist">
                <ul id="js-playlist-con">
                    
                </ul>
            </div>
        </div>
        <div class="player-wrap" id="js-audio">
          <!-- <audio id="ez-player" class="video-js"><source src="http://sk.cri.cn/am846.m3u8" type="application/x-mpegURL"></audio> -->
        </div>
        <div class="player-rel">
            <!--<span title="分享" class="m-player-share-btn"></span>-->
            <span title="播放列表" class="player-list-btn" @click.stop.prevent="" @click="isPlayList"></span>
        </div>
    </div>
    
  </div>
</template>

<script>
import videojs from 'video.js'

export default {
  name: 'Player',
  data () {
    return {
      //音频播放器全局变量
      globalPlayer:null,
      //播放列表初始数量
      playListIndex:0,
      idList:[],
      initPlayer:true,
      onAirInfoData:{},
    }
  },
  methods:{
    /**
     * 音频播放默认参数
     */
    myDefaultOptions:function() {
      var _self = this;
        //pc、pad
        var myOptions = {
            width: 600,
            height: 65,
            controls: true,
            volumePanel: false,
            bigPlayButton: false,
            textTrackDisplay: false,
            posterImage: false,
            errorDisplay: false,
            controlBar: {
                children: ['playToggle',/*'currentTimeDisplay','timeDivider','durationDisplay',*/'progressControl', 'volumePanel', 'liveDisplay'],//包含的子元素以及生成顺序
                //fullscreenToggle:false,//全屏
                //ProgressControl:true,//时间条
                volumePanel: {
                    inline: false//竖条
                }
            }
        };
        //手机
        var myOptionsMobile = {
            //width:'100%',
            //height:'auto',
            controls: true,
            volumePanel: false,
            bigPlayButton: false,
            textTrackDisplay: false,
            posterImage: false,
            errorDisplay: false,
            controlBar: {
                children: ['playToggle', 'progressControl', 'liveDisplay']//包含的子元素以及生成顺序
            }
        };
        var _w = document.documentElement.clientWidth;
        return _w < 544 ? myOptionsMobile : myOptions;
    },

    /**
     * 音频播放添加组件
     */
    myComponent:function() {
      var _self = this;
        var Component = videojs.getComponent('Component');

        //标题
        var titleBar = videojs.extend(Component, {
            constructor: function (player, options) {
                Component.apply(this, arguments);
                if (options.text) {
                    this.updateTextContent(options.text);
                }
            },
            createEl: function () {
                return videojs.dom.createEl('div', {
                    className: 'vjs-title-bar'
                });
            },
            updateTextContent: function (text) {
                if (typeof text !== 'string') {
                    text = 'Title Unknown';
                }
                videojs.dom.emptyEl(this.el());
                videojs.dom.appendContent(this.el(), text);
            }
        });
        videojs.registerComponent('titleBar', titleBar);

        //相关说明
        var infoBar = videojs.extend(Component, {
            constructor: function (player, options) {
                Component.apply(this, arguments);
                if (options.text) {
                    this.updateInfoContent(options.text);
                }
            },
            createEl: function () {
                return videojs.dom.createEl('div', {
                    className: 'vjs-info-bar'
                });
            },
            updateInfoContent: function (text) {
                if (typeof text !== 'string') {
                    text = 'Info Unknown';
                }
                videojs.dom.emptyEl(this.el());
                videojs.dom.appendContent(this.el(), text);
            }
        });
        videojs.registerComponent('infoBar', infoBar);

        //标题图片
        var headImg = videojs.extend(Component, {
            constructor: function (player, options) {
                Component.apply(this, arguments);
                if (options.imgurl) {
                    this.updateImgSrc(options.imgurl);
                }
            },
            createEl: function () {
                return videojs.dom.createEl('img', {
                    className: 'vjs-head-img'
                });
            },
            updateImgSrc: function (url) {
                if (typeof url !== 'string') {
                    url = '/';
                }
                this.el().src = url;
            }
        });
        videojs.registerComponent('headImg', headImg);
    },

    

    addPlayList:function(data){
      var _self = this;
        var _id = data.title,
            _isAdd = true,
            _index = 0;
        for(var i=0; i<_self.idList.length; i++){
            if(_id == _self.idList[i]){
                _isAdd = false;
                _index = i;
            }
        }
        if(_isAdd){
            _self.idList.unshift(data.title);
            //加入到播放列表
            $('#js-playlist-con').prepend('<li data-id="" data-type="'+ data.type +'" data-title="'+ data.title +'" data-date="'+ data.date +'" data-time="'+ data.time +'" data-img="" data-announcer="'+ data.announcer +'" data-url="'+ data.url +'" data-program-title="'+ data.programTitle +'"><span class="pl-ind">1</span><span class="pl-title">'+ data.title +'</span><span class="pl-date">'+ data.date +'</span><span class="pl-announcer">'+ data.announcer +'</span><span class="pl-time">'+ data.time +'</span></li>');
            var pl = 1;
            $('.pl-ind').each(function(){
                $(this).html(pl);
                pl++;
            })
        }
        _self.playListIndex = _index;
        var _itemList = $('#js-playlist-con li'),
            _itemListLength = _itemList.length-1;
        _itemList.eq(_index).addClass('current').siblings().removeClass('current');
        //切换播放列表曲目
        _self.changeStyle(_itemListLength);
    },

    initPlayerFirst:function() {
      var _self = this;
        if (_self.initPlayer == true) {
            _self.initPlayer = false;
            return true;
        } else {
            return false;
        }
    },

    /**
     * 音频播放器
     * @param  {type}     elem      元素id
     * @param  {Boolean}  play      是否播放，默认false
     * @param  {Function} callback  要执行的函数
     */
    audioPlay:function(id, play, callback) {
      var _self = this;
        if (!id) {
            var date = new Date();
            var month = date.getMonth() + 1;
            var strDate = date.getDate();
            var _play = play || false,
                _isLive = false,
                data = {
                    title: '轻松调频',
                    date: '2019-04-01',
                    time: '00:00-23:59',
                    imgurl: './img/pic1.jpg',
                    programTitle: '',
                    announcer: '',
                    type: 'application/x-mpegURL',
                    url: 'http://sk.cri.cn/915.m3u8'
                };
        } else {
            var _id = id,
                _play = play || false,
                _isLive = _id.attr('data-type') == 'live' ? false : true,
                data = {
                    title: _id.attr('data-title') || 'cri',
                    date: _id.attr('data-date') || '0000-00-00',
                    time: _id.attr('data-time') || '00:00-23:59',
                    imgurl: _id.attr('data-img') || './img/pic1.jpg',
                    programTitle: _id.attr('data-program-title') || '',
                    announcer: _id.attr('data-announcer') || '',
                    type: reType(_id.attr('data-type')) || 'application/x-mpegURL',
                    url: _id.attr('data-url') || 'http://sk.cri.cn/915.m3u8'
                };
                
            //通过样式判断是否首次播放
            if (_id.hasClass('js-play')){
                //非首次，不做注销、重载处理
                if (_self.globalPlayer.paused() && _play) {
                    _self.globalPlayer.play();
                    _id.addClass('play');
                } else {
                    _self.globalPlayer.pause();
                    _id.removeClass('play');
                }
                return false;
            } else {
                //首次添加判断样式
                // $(window.frames[0].document).find('.js-play').removeClass('js-play');
                $('.js-play').removeClass('js-play');
                _id.addClass('js-play');
            }
            
        }

        /**
         * 返回格式类型
         */
        function reType(type) {
            var _type = type || 'application/x-mpegURL';
            switch (_type) {
                case 'live':
                    _type = 'application/x-mpegURL';
                    break;
                case 'mp3':
                    _type = 'audio/mpeg';
                    break;
                default:
                    break;
            }
            return _type;
        };

        _self.addPlayList(data);
        //新源加载
        $('.vjs-title-bar').html(data.title);
        $('.vjs-info-bar').html(data.date + ' | ' + data.time + ' | ' + data.programTitle);
        _self.globalPlayer.src({
            src: data.url,
            type: data.type
        });
        //判断是不是直播，不是直播则添加上一条下一条事件
        if (_isLive) {
           
        } else {
            var _h = $('.vjs-title-bar').html();
            _h = _h;
            $('.vjs-title-bar').html(_h);
        }
        //由于ff问题删除
        //globalPlayer.load();

        if (_play) {
            _self.globalPlayer.play();
        }
        // 上下联动播放按钮状态逻辑，需要在css中添加play的样式
        // _id.addClass('allPlayBtn');
        // if(_id.hasClass('play')){
        //     _self.globalPlayer.pause();
        //     _id.removeClass('play');
        // }else{
        //     _self.globalPlayer.play();
        //     $('.allPlayBtn').removeClass('play');
        //     _id.addClass('play');
        // }

        if (callback) {
            callback();
        }
    },
    
    /**
     * 音频播放器初始化
     */
    audioInit:function(){
      var _self = this;
        //刷新时需要先注销
        if($('#js-my-audio').length>0){
            //globalPlayer = videojs('js-my-audio');
            // globalPlayer.dispose();
        }
        
        // $('#js-audio').html('<audio id="js-my-audio" class="video-js"><source src="//sk.cri.cn/915.m3u8" type="application/x-mpegURL"></audio>');
        $('#js-audio').html('<audio id="js-my-audio" preload="auto" class="video-js"><source src="//sk.cri.cn/915.m3u8" type="application/x-mpegURL"></audio>');
        
        //重载
        _self.globalPlayer = videojs('js-my-audio',_self.myDefaultOptions());  //初始化视频
        
        // //加载组件
        _self.globalPlayer.addChild('titleBar',{},2);
        
        _self.globalPlayer.addChild('infoBar',{
            text:''
        },3);
        //图片
        //player.addChild('headImg',{imgurl:data.imgurl});
		_self.globalPlayer.on('play',function(){ //播放
			// if(_hmt != undefined && $('.vjs-title-bar').text()){
			//   _hmt.push(['_trackEvent', 'audio', 'play', $('.vjs-title-bar').text()]);
            // }
            if(_self.globalPlayer.cache_.source.type == 'application/x-mpegURL'){//直播
                $('.js-liveBtns-play').addClass('play');
            }else{
                $('.js-liveBtns-play').removeClass('play');
            }
            var audioP = $('.js-detail-audio-player');
            var videoP = $('.js-detail-video-player');
            if(audioP.length > 0){
                audioP.get(0).pause();
            }
            if(videoP.length > 0){
                videoP.get(0).pause();
            }
            var _curPage = $(_self.$parent.$children[3].$el) , _ArticleVideoPlayer , _ArticleaudiooPlayer;
            if(_curPage.attr('class') != 'detail body'){
                _ArticleVideoPlayer = _self.$parent.$children[1].videoLivePlayer;
                _ArticleaudiooPlayer = _self.$parent.$children[1].audioLivePlayer;
            }else{
                _ArticleVideoPlayer = _self.$parent.$children[3].videoLivePlayer;
                _ArticleaudiooPlayer = _self.$parent.$children[3].audioLivePlayer;
                
            }
            
            if(_ArticleVideoPlayer != null && _ArticleVideoPlayer != undefined){
                _ArticleVideoPlayer.pause();
            }
            if(_ArticleaudiooPlayer != null && _ArticleaudiooPlayer != undefined){
                _ArticleaudiooPlayer.pause();
            }
		})
		_self.globalPlayer.on('pause',function(){  //暂停
			// if(_hmt != undefined && $('.vjs-title-bar').text()){
			//   _hmt.push(['_trackEvent', 'audio', 'pause', $('.vjs-title-bar').text()]);
            // }
            $('.js-liveBtns-play').removeClass('play');
		});
        var prevBtn = _self.globalPlayer.controlBar.addChild('button',{},0);
        prevBtn.addClass('vjs-icon-previous-item');
        prevBtn.addClass('none');
        var nextBtn = _self.globalPlayer.controlBar.addChild('button',{},2);
        nextBtn.addClass('vjs-icon-next-item');
        prevBtn.on('click',function(){
            _self.changeMedia(-1);
        });
        nextBtn.on('click',function(){
            _self.changeMedia(1);
        });
    },
    
    /**
     * 切换历史列表曲目
     */
    changeMedia:function(i){
      var _self = this;
        var _item = $('#js-playlist-con li'),
            _itemLength = _item.length-1;
        _self.playListIndex+=i;
        if(_self.playListIndex<0){
            _self.playListIndex = 0;
        }else if(_self.playListIndex>_itemLength){
            _self.playListIndex = _itemLength;
        }else{
            var _this = _item.eq(_self.playListIndex);
            _self.audioPlay(_this,true);
        }
    },

    /**
     * 切换历史列表曲目
     */
    changeStyle:function(max){
      var _self = this;
        var _prev = $('.vjs-icon-previous-item'),
            _next = $('.vjs-icon-next-item');
        if(_self.playListIndex==0){
            _prev.addClass('none');
            _next.removeClass('none');
        }else if(_self.playListIndex==max){
            _next.addClass('none');
            _prev.removeClass('none');
        }else{
            _prev.removeClass('none');
            _next.removeClass('none');
        }
    },

    /**
     * 整体函数调用相关
     */
    init:function() {
        var _self = this;
        if ($('#js-audio').length > 0) {
            //播放器开始
            _self.myComponent();//播放器相关组件创建，必要
            _self.audioInit();//初始
            _self.getLiveData();
            $('#js-playlist-con').on('click', 'li', function () {
                var _this = $(this);
                _this.addClass('current').siblings().removeClass('current');
                _self.audioPlay(_this, true);
            });
            //audioPlay();
            //播放器结束
        }

    },
    isPlayList:function(){
        if($('#js-playlist').css('display') == 'none'){
            $('#js-playlist').show(200);
        }else{
            $('#js-playlist').hide(200);
        }
    },
    closePlayList:function(){
        $('#js-playlist').hide(200);
    },
    playerInfoFirstInit:function(){
      var _this = this;
      _this.$nextTick(function(){
        var startTime = _this.onAirInfoData.startTime.substring(0,5) , stopTime = _this.onAirInfoData.stopTime.substring(0,5);
        $('.vjs-title-bar').text(_this.onAirInfoData.title);
        $('.vjs-info-bar').text(_this.onAirInfoData.day+' | '+startTime+'-'+stopTime+' | '+_this.onAirInfoData.programTitle);
      })
    },
    getLiveData:function(){
      var _this = this;
      _this.$http.post('/qertyuiy/v3/live?session=8295f0a6-6804-4d61-8944-4f8d60a71cd4')
      .then(function(res){    
        var onAirInfo = res.data.onair
        _this.onAirInfoData = onAirInfo;
        _this.playerInfoFirstInit();
      })
      .catch(function(e){

      })
    },
  },
  mounted:function(){
    this.init();
    $(document).on('click',function(event){
        var _con = $('#js-playlist');
        if(!_con.is(event.target) && _con.has(event.target).length === 0){ // Mark 1
           $('#js-playlist').hide(200);
        }
    })
  },
}
</script>

<style scoped lang="scss">
  .player{
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    border-top: solid 1px #999;
    background: url('../../static/img/player-bg.png') repeat-x 50% 50%;
    background-size: auto 100%;
    height: 66px;
    z-index: 9999;
    .playerCon{width:1080px;margin:0 auto;}
    .playerCon audio{display:none;}
    /*player-wrap*/
    .player-wrap{width:600px;margin-right:70px;float:left;overflow:visible;}

    /*video-js 1em=12px*/
    /deep/ .playerCon .video-js{background-color:transparent;font-size:12px;}
    /deep/ .playerCon .video-js .vjs-control-bar{position: absolute;bottom: 9px;height: 48px;display: block;margin-top: 0;margin-bottom: 0;background-color: transparent;align-items: center;justify-content: center;}
    /deep/ .playerCon .video-js .vjs-control{float:left;}
    /deep/ .playerCon .video-js .vjs-play-control{width:48px;height:48px;border:solid 2px #fff;border-radius:50%;margin:0;display:block;}
    /deep/ .playerCon .vjs-icon-previous-item,/deep/ .playerCon .vjs-icon-next-item{width:50px;font-size:3em;}
    /deep/ .playerCon .vjs-icon-previous-item.none,/deep/ .playerCon .vjs-icon-next-item.none{color:#666;}
    /deep/ .playerCon .video-js .vjs-fullscreen-control,/deep/ .playerCon .video-js .vjs-remaining-time{display:none;}
    /deep/ .playerCon .video-js .vjs-current-time,/deep/ .playerCon .vjs-no-flex .vjs-current-time,/deep/ .playerCon .vjs-time-divider,/deep/ .playerCon .video-js .vjs-duration,/deep/ .playerCon .vjs-no-flex .vjs-duration{display:block;}
    /deep/ .playerCon .video-js .vjs-time-control{padding-left:0;padding-right:0;text-align:center;color:#a0a0a0;float:left;line-height:48px;font-size:12px;display:none;}
    /deep/ .playerCon .video-js .vjs-current-time-display{color:#00aef5;}
    /deep/ .playerCon .video-js .vjs-play-progress{background-color:#00aef5;}
    /deep/ .playerCon .vjs-button > .vjs-icon-placeholder:before {font-size:3em;line-height:48px;}
    /deep/ .playerCon .video-js .vjs-progress-control{position:absolute;left:210px;bottom:-9px;width:58%;height:20px;}
    /deep/ .playerCon .video-js .vjs-volume-panel{display:flex;}
    /deep/ .playerCon .video-js .vjs-volume-panel.vjs-volume-panel-vertical{float:right;font-size:.7em;}
    /deep/ .playerCon .video-js .vjs-live-control{line-height:48px;flex:0;}
    /deep/ .playerCon .vjs-live-display{position:absolute;left:30px;top:-4px;width:34px;height:16px;font-size:12px;text-align:center;background-color:#00aef5;color:#fff;border-radius:2px;line-height:16px;z-index:1;}
    /deep/ .playerCon .video-js .vjs-volume-vertical{background-color:rgba(87,88,88,.7);}
    /deep/ .playerCon .video-js .vjs-slider-vertical .vjs-volume-level:before{left: -.4em;}
    /*my*/
    /deep/ .playerCon .vjs-title-bar,/deep/ .playerCon .vjs-info-bar,/deep/ .playerCon .vjs-head-img{position:absolute;text-align:left;}
    /deep/ .playerCon .vjs-title-bar{font-size: 14px;top: 10px;margin-top: 0; width: 330px;left: 220px;position: absolute;text-align: left;z-index: 1;height: 20px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;color: #fff;}
    /deep/ .playerCon .vjs-info-bar{left:220px;font-size: 12px;top: 30px;padding-top: 0;width: 330px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;color: #fff;}
    /deep/ .playerCon .vjs-head-img{width:48px;height:48px;top:9px;left:150px;}

    .player-rel{float:left;margin-top:17px;display:block;}
    .player-rel span{display:block;width:30px;height:30px;float:left;background-image:url('../../static/img/m-player.png');background-repeat:no-repeat;cursor:pointer;}
    .player-share-btn{background-position:0 0;}
    .player-collect-btn{background-position:-30px 0;}
    .player-list-btn{background-position:-60px 0;}
    .player-other-btn{background-position:-90px 0;}
    /*play-list*/
    /deep/ .player-audio-list{position:absolute;left:50%;bottom:66px;margin-left:-540px;width:1080px;height:300px;background-color:rgba(68,68,68,.9);color:#fff;border-top-left-radius:10px;border-top-right-radius:10px;display:none;}
    /deep/ .playlist-top{height:39px;line-height:39px;padding-left:30px;border-bottom:solid 1px #000;}
    /deep/ .playlist-top h4{float:left;font-size:16px;}
    /deep/ .playlist-top .close{float:right;width:40px;height:39px;font-size:14px;text-align:center;cursor:pointer;}
    /deep/ .playlist{height:260px;color:#ccc;/*overflow:hidden;*/overflow-y:scroll;}
    /deep/ .playlist::-webkit-scrollbar-track{border-radius:3px;background-color:transparent;}
    /deep/ .playlist::-webkit-scrollbar{width:6px;background-color:transparent;}
    /deep/ .playlist::-webkit-scrollbar-thumb{border-radius:3px;background-color:rgba(0,0,0,.3);}

    /deep/ .playlist li{height:30px;padding-right:30px;font-size:14px;line-height:30px;cursor:pointer;}
    /deep/ .playlist li.current,/deep/ .playlist li:hover{background-color:#202020;color:#fff;}
    /deep/ .playlist li:before{float:left;display:block;width:30px;height:30px;font-family:VideoJS;content:"";text-align:center;}
    /deep/ .playlist li.current:before{content:"\f101";}
    /deep/ .playlist li span{display:block;float:left;height:30px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;}
    /deep/ .playlist li span.pl-ind{width:30px;}
    /deep/ .playlist li span.pl-date,/deep/ .playlist li span.pl-announcer,/deep/ .playlist li span.pl-time{display:none;}
    /deep/ .playlist li span.pl-title{width:40%;}
    /deep/ .playlist li span.pl-date{display:block;width:10%;}
    /deep/ .playlist li span.pl-announcer{display:block;width:25%;}
    /deep/ .playlist li span.pl-time{display:block;float:right;}
  }
  @media screen and (max-width: 900px) {
      .player{
          height: auto;
        .playerCon{width:100%;}
        .player-wrap{width: 100%;}
        /deep/ .player-wrap .video-js{width:100%;height:auto;}
        /deep/ .player-wrap .video-js .vjs-control-bar{position:relative;height:48px;margin-top:10px;margin-bottom:30px;background-color:transparent;display:-webkit-flex;display:flex;align-items:center;justify-content:center;bottom: 0px;}
        /deep/ .player-wrap .video-js .vjs-play-control{width:48px;height:48px;border:solid 2px #fff;border-radius:50%;margin:0;display:block;}
        /deep/ .player-wrap .vjs-icon-previous-item,/deep/ .player-wrap .vjs-icon-next-item{width:50px;font-size:3em;}
        /deep/ .player-wrap .vjs-icon-previous-item.none,/deep/ .player-wrap .vjs-icon-next-item.none{color:#666;}
        /deep/ .player-wrap .video-js .vjs-fullscreen-control,.video-js .vjs-remaining-time{display:none;}
        /deep/ .player-wrap .video-js .vjs-current-time,.vjs-no-flex .vjs-current-time,.vjs-time-divider,.video-js .vjs-duration,.vjs-no-flex .vjs-duration{display:block;}
        /deep/ .player-wrap .video-js .vjs-time-control{padding-left:0;padding-right:0;text-align:center;color:#a0a0a0;float:left;line-height:48px;font-size:12px;display:none;}
        /deep/ .player-wrap .video-js .vjs-current-time-display{color:#00aef5;}
        /deep/ .player-wrap .video-js .vjs-play-progress{background-color:#00aef5;}
        /deep/ .player-wrap .vjs-button > .vjs-icon-placeholder:before {font-size:3em;line-height:48px;}
        /deep/ .player-wrap .video-js .vjs-progress-control{position:absolute;left:0;bottom:-30px;width:100%;height:20px;}
        /deep/ .player-wrap .video-js .vjs-volume-panel{display:none;}
        /deep/ .player-wrap .video-js .vjs-live-control{line-height:48px;flex:0;}
        /deep/ .player-wrap .vjs-live-display{position:absolute;left:0;top:-4px;width:34px;height:16px;font-size:12px;text-align:center;background-color:#00aef5;color:#fff;border-radius:2px;line-height:16px;z-index:1;}

        /deep/ .player-wrap .video-js .vjs-volume-vertical{background-color:rgba(87,88,88,.7);}
        /deep/ .player-wrap .vjs-title-bar,/deep/ .player-wrap .vjs-info-bar,/deep/ .player-wrap .vjs-head-img{position:static;text-align:center;}
        /deep/ .player-wrap .vjs-title-bar,.vjs-info-bar,/deep/ .player-wrap .vjs-title-bar a{color:#fff;}
        /deep/ .player-wrap .vjs-title-bar{font-size:14px;margin-top:10px;z-index:1;height:20px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;width: auto;}
        /deep/ .player-wrap .vjs-info-bar{font-size:12px;padding-top:5px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;width: auto;}
        /deep/ .player-wrap .vjs-head-img{width:48px;height:48px;top:9px;left:150px;}
        .player-rel{display: none;}
      }
  }
</style>



// WEBPACK FOOTER //
// src/components/Player.vue